import React, { useState } from 'react';
import styled from 'styled-components';
import Modal from '~ComponentsImproved/Modal';
import { Badge, Box, Button, Card, Input } from '~Styles';
import { handyBreakpoint } from '~Styles/breakpoints';

const ModalCard = styled(Card)`
  width: 450px;
  ${handyBreakpoint} {
    width: 100%;
  }
`;

const HistoryItem = styled(Badge)`
  display: inline-block;
  margin-right: 6px;
`;

HistoryItem.defaultProps = {
  backgroundColor: 'colorBlueGray300',
};

export default function DevBranchModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const history = localStorage.getItem('branch-history')?.split(',') || [];
  const [branchName, setBranchName] = useState('');

  // Passing in name here to prevent context issue
  const openBranch = (name?: string) => {
    const branch = name || branchName;
    if (!history.includes(branch)) {
      localStorage.setItem('branch-history', [branch, ...history].join(','));
    }

    window.location.replace(`https://ordermanager-git-${branch}-baemingo.vercel.app/`);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (!branchName) {
      return;
    }
    openBranch();
  };

  return (
    <Modal isShowing={open} hide={onClose}>
      <ModalCard padding="large">
        <form onSubmit={handleSubmit}>
          <Input
            autoCorrect="false"
            autoCapitalize="none"
            fluid
            placeholder="Branch name, e.g my-cool-feature"
            marginBottom="small"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBranchName(e.target.value)}
          />
          <Box marginBottom="small">
            {history.slice(0, 5).map((branch) => (
              <Badge
                display="inline-block"
                backgroundColor="colorBlack"
                color="colorWhite"
                padding="small"
                marginRight="xs"
                marginBottom="xs"
                onTouchEnd={() => {
                  setBranchName(branch);
                  openBranch(branch);
                }}>
                {branch}
              </Badge>
            ))}
          </Box>
          <Button
            padding="large"
            fluid
            backgroundColor="colorStatusBlue"
            color="colorWhite"
            type="submit">
            Go to branch
          </Button>
        </form>
      </ModalCard>
    </Modal>
  );
}
